import { api } from '../client/axiosClient';
import { CustomResponseEntity } from '../types/dtos/common';
import { ChallengeFindingDto } from '../types/dtos/challenge';

/**
 * Challenge Finding Service handles CRUD operations for challenge findings.
 *
 * URL Pattern: /api/v1/inspections/{challengeId}/findings
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths.
 * The backend extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * @deprecated organizationId parameter is deprecated and no longer used.
 */

class ChallengeFindingService {
  async findAll(
    _organizationId: string,
    challengeId: string,
    isActive?: boolean
  ): Promise<CustomResponseEntity<ChallengeFindingDto[]>> {
    return api.get(`/api/v1/inspections/${challengeId}/findings`, {
      params: { isActive },
    });
  }

  async findById(
    _organizationId: string,
    challengeId: string,
    id: string
  ): Promise<CustomResponseEntity<ChallengeFindingDto>> {
    return api.get(`/api/v1/inspections/${challengeId}/findings/${id}`);
  }

  async create(
    _organizationId: string,
    challengeId: string,
    data: ChallengeFindingDto
  ): Promise<CustomResponseEntity<ChallengeFindingDto>> {
    return api.post(`/api/v1/inspections/${challengeId}/findings`, data);
  }

  async update(
    _organizationId: string,
    challengeId: string,
    id: string,
    data: ChallengeFindingDto
  ): Promise<CustomResponseEntity<ChallengeFindingDto>> {
    return api.put(
      `/api/v1/inspections/${challengeId}/findings/${id}`,
      data
    );
  }

  async delete(
    _organizationId: string,
    challengeId: string,
    id: string
  ): Promise<CustomResponseEntity<void>> {
    return api.delete(`/api/v1/inspections/${challengeId}/findings/${id}`);
  }
}

export const challengeFindingService = new ChallengeFindingService(); 